import { useCompany } from "@/api/services/admin/company";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { CompanyForm } from "@/features/company/components/CompanyForm";
import { convertCompanyResToForm } from "@/features/company/utils/converts";
import { Stack } from "@mui/material";
import { FC } from "react";

type TCompanyEditPageProps = {};

export const CompanyEditPage: FC<TCompanyEditPageProps> = () => {
  const { data: companyResult, isLoading } = useCompany();
  const companyData = companyResult?.data;

  if (isLoading || !companyData) return <LoadingPage />;

  return (
    <Stack gap={4}>
      <TopPage title="受け入れ企業を編集" enablePageBack={false} />
      <CompanyForm previousData={convertCompanyResToForm(companyData)} />
    </Stack>
  );
};
